export const RIGHT_FAMILY_POLICY_NOTIFICATION_REPORT = 131224